import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { useCheckAdminInWebview } from './utils/hooks';
import EventSuperAdminLayout from './containers/admin/EventSuperAdminLayout';
import ComplianceAdminStatistics from './components/AnglingTrust/admin/components/stats/ComplianceAdminStatistics';

export const event_super_admin_url = '/events_management';

function EventSuperAdminRouter() {
  useCheckAdminInWebview();

  return (
    <>
      <Switch>
        <Route>
          {/* Components nested within <EventSuperAdminLayout/> will be secured from un-authorised access (redirected to log-in page) */}
          <EventSuperAdminLayout>
            <Switch>
              <Route
                exact
                path={`${event_super_admin_url}/stats`}
                component={ComplianceAdminStatistics}
              />
              <Route>
                <Redirect to={`${event_super_admin_url}/stats`} />
              </Route>
            </Switch>
          </EventSuperAdminLayout>
        </Route>
      </Switch>
    </>
  );
}

export default EventSuperAdminRouter;
